import { gameRunningStatuses } from 'config/gameRunningStatuses';
import {
    getUserGameEntry,
    getUserLatestEntry,
    checkShouldGetNextEntry,
    overwriteEntryAction,
    getEntryQualificationInfo
} from 'client/hooks/useInitPromo/userEntryState/getUserEntry';

export default async function getUserEntryState({
    state,
    dispatch,
    abortHelper,
    recaptchaToken,
    enableQualificationPasscode,
    enableReCaptcha
}) {
    const {
        promoState: {
            periodPlayMatchedInfo: { matchedInfo: { match: isInPlayTimePeriod } = {} } = {},
            gameRunningStatus
        }
    } = state;
    const isPromoPlayableOnTime =
        gameRunningStatus === gameRunningStatuses.RUNNING && isInPlayTimePeriod;
    async function canContinueFlow() {
        return isPromoPlayableOnTime && (await abortHelper.current.canContinue());
    }

    let latestEntry = await getUserLatestEntry({ state });
    if (await canContinueFlow()) {
        const shouldGetNextEntry = checkShouldGetNextEntry({
            state,
            latestEntry
        });

        // 啟用 reCaptcha 時，若有啟用通關序號，reCaptcha 會在通關序號時驗證，反之，會在 create entry 驗證
        const isReCaptchaPass =
            (Boolean(enableReCaptcha) && !enableQualificationPasscode && Boolean(recaptchaToken)) ||
            (Boolean(enableReCaptcha) && Boolean(enableQualificationPasscode)) ||
            !enableReCaptcha;

        // 需要產生新的 entry
        if (shouldGetNextEntry) {
            if (isReCaptchaPass) {
                const {
                    entry: gameEntry,
                    createEntryNotQualifiedType = '',
                    hasPromoSuspended: hasPromoSuspendedWhenGetEntries
                } = await getUserGameEntry({
                    dispatch,
                    state,
                    latestEntry,
                    recaptchaToken
                });
                const { entryId, entryUuid = '', ...restEntryProps } = gameEntry;
                return {
                    ...restEntryProps,
                    ...(hasPromoSuspendedWhenGetEntries
                        ? {}
                        : await getEntryQualificationInfo({
                              state,
                              entry: gameEntry
                          })),
                    createEntryNotQualifiedType,
                    currentEntryId: entryId,
                    currentEntryUUID: entryUuid,
                    shouldGetNextEntry: false
                };
            } else return { shouldGetNextEntry: true };
        } else {
            // 新的 entry 已建立，但還沒結束這ㄧ回合
            const { entryId, entryUuid = '', ...restEntryProps } = latestEntry;
            return {
                ...restEntryProps,
                ...(await getEntryQualificationInfo({
                    state,
                    entry: latestEntry
                })),
                currentEntryId: entryId,
                currentEntryUUID: entryUuid
            };
        }
    } else {
        // 當有 game result 且略過填表時，活動不可玩時，略過填表和配獎
        const { entryId, entryUuid = '', ...restEntryProps } = overwriteEntryAction(latestEntry);
        return {
            ...restEntryProps,
            currentEntryId: entryId,
            currentEntryUUID: entryUuid
        };
    }
}
